const API_URL = process.env.REACT_APP_API_URL;

// Export configuration as an object similar to the original settings.json
const config = {
  api_url: API_URL
};

export default config;
